import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { countActionable } from "./model";
import { useApprovals, useMinuteClock } from "./use-approvals";

/** The pending count while approvals have loaded, else null (no badge while loading or failing). */
export function usePendingCount(): number | null {
  const state = useApprovals("pending");
  const now = useMinuteClock();
  return state.status === "ready" ? countActionable(state.approvals, now) : null;
}

/** "Approvals" in the shell's nav, with a badge counting what waits for the person. */
export function ApprovalsNavLink({ className, icon, labelClass }: { className: string; icon?: ReactNode; labelClass?: string }) {
  const count = usePendingCount();
  const waiting = count !== null && count > 0;
  return (
    <Link to="/approvals" className={className} title="Approvals">
      {icon}
      <span className={labelClass === undefined ? "flex-1" : `flex-1 ${labelClass}`}>Approvals</span>
      {waiting ? (
        <span className="ml-2 inline-grid min-w-5 place-items-center rounded-full bg-accent px-1.5 text-xs font-semibold text-accent-contrast">
          {count}
          <span className="sr-only"> waiting</span>
        </span>
      ) : null}
    </Link>
  );
}
